import React, { useEffect, useState } from "react";
import { api } from "../../../software/api";
import { toast } from "sonner";
import { CalendarPlus } from "lucide-react";

// shown after a Work Order is set to Completed: book the next regular service (date from the client's service contract)
export default function NextServiceModal({ wo, onClose }) {
  const [info, setInfo] = useState(null), [date, setDate] = useState(""), [tech, setTech] = useState(wo.technician || ""), [team, setTeam] = useState([]), [busy, setBusy] = useState(false);
  useEffect(() => {
    api("GET", `/next-service/suggest?client_id=${wo.client_id}`).then((r) => { setInfo(r); setDate(r.date); }).catch(() => {});
    api("GET", "/team").then((t) => setTeam((t || []).map((x) => x.name).filter(Boolean))).catch(() => {});
  }, [wo.client_id]);
  const book = async () => {
    if (!date) return;
    setBusy(true);
    try {
      const n = await api("POST", "/next-service", { client_id: wo.client_id, date, technician: tech, prev_wo_id: wo.id });
      toast.success(`Next regular service booked — W/O ${n.wo_number} on ${(n.scheduled_date || date).split("-").reverse().join("/")}${tech ? ` for ${tech}` : ""}`);
      onClose(true);
    } catch (e) { toast.error(e.message); setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[90] bg-black/40 flex items-center justify-center p-4" data-testid="next-service-modal">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="px-5 py-3 bg-emerald-700 text-white font-black flex items-center gap-2"><CalendarPlus className="h-5 w-5" />W/O {wo.wo_number} completed — book the next regular service?</div>
        <div className="p-5 space-y-3 text-sm">
          <div className="text-slate-600" data-testid="next-service-freq">Service contract: <b>{info ? info.frequency : "…"}</b></div>
          <label className="block"><span className="text-xs font-bold text-slate-500">NEXT SERVICE DATE</span>
            <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="next-service-date" className="mt-1 w-full h-10 border-2 border-slate-200 rounded px-2 font-bold" /></label>
          <label className="block"><span className="text-xs font-bold text-slate-500">TECHNICIAN</span>
            <select value={tech} onChange={(e) => setTech(e.target.value)} data-testid="next-service-tech" className="mt-1 w-full h-10 border-2 border-slate-200 rounded px-2 font-bold">
              <option value="">Unassigned</option>{team.map((n) => <option key={n}>{n}</option>)}
            </select></label>
          <div className="text-xs text-slate-500">Creates a new booked Work Order with the service contract wording and puts its magnet on the White Board. A Saturday or Sunday moves to the Monday.</div>
        </div>
        <div className="px-5 pb-5 grid grid-cols-2 gap-2">
          <button onClick={() => onClose(false)} data-testid="next-service-skip" className="h-11 rounded-lg border-2 border-slate-300 font-bold text-slate-700 hover:bg-slate-50">Do not book another work order</button>
          <button onClick={book} disabled={busy || !date} data-testid="next-service-book" className="h-11 rounded-lg bg-emerald-600 text-white font-black hover:bg-emerald-700 disabled:opacity-50">Book next service</button>
        </div>
      </div>
    </div>
  );
}
